exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".switch[data-v-3636752c] {\n  display: flex;\n  align-items: center;\n}\n.switch span[data-v-3636752c] {\n  font-family: Akkurat-Light;\n  font-size: 20px;\n  font-weight: 300;\n}\n.switch__off[data-v-3636752c] {\n  opacity: 0.3;\n}", ""]);

// exports
